<template>
    <div class="field-wrap">
        <app-checkbox
            :label="label"
            :data-source="dataSource + '.active'"
            revalidate-source="link"
        ></app-checkbox>

        <app-text
            v-show="getProp(dataSource + '.active') == 1"
            :label="'Beschriftung'"
            :data-source="dataSource + '.text'"
            :data-default="{ type: 'textpicker' }"
            textpicker-namespace="misc/link"
            :maxlength="30"
        ></app-text>

        <app-select
            v-show="
                getProp(dataSource + '.active') == 1 &&
                    !hideInternal &&
                    !getProp(dataSource + '.url')
            "
            :label="'Interner Link'"
            :data-source="dataSource + '.page_id'"
            :options="items"
            :required="
                getProp(dataSource + '.active') == 1 &&
                    !hideInternal &&
                    !getProp(dataSource + '.url')
            "
            revalidate-source="link"
            revalidate-target="link"
        ></app-select>

        <app-text
            v-show="
                getProp(dataSource + '.active') == 1 &&
                    !hideExternal &&
                    !getProp(dataSource + '.page_id')
            "
            :label="'Externer Link'"
            :data-source="dataSource + '.url'"
            pattern="^(https?:\/\/(www\.)?)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?\&\/\/=]*)$"
            autoformat="url"
            :maxlength="255"
            :required="
                getProp(dataSource + '.active') == 1 &&
                    !hideExternal &&
                    !getProp(dataSource + '.page_id')
            "
            revalidate-source="link"
            revalidate-target="link"
        ></app-text>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toArray } from '@/helpers/utils';
import Text from '@/components/fields/simple/Text.vue';
import Select from '@/components/fields/simple/Select.vue';
import Checkbox from '@/components/fields/simple/Checkbox.vue';

export default {
    components: {
        'app-text': Text,
        'app-select': Select,
        'app-checkbox': Checkbox
    },
    computed: {
        ...mapGetters(['getProp', 'getPages', 'getActivePageId']),
        items() {
            let selectPages = {},
                pages = this.getPages;
            if (pages !== undefined && pages !== null && Object.keys(pages).length > 0) {
                toArray(pages)
                    .sort((a, b) => a.name - b.name)
                    .filter((i) => i.id !== this.getActivePageId)
                    .forEach((pages__value) => {
                        selectPages[pages__value.id] = pages__value.name;
                    });
            }
            return selectPages;
        }
    },
    props: {
        label: String,
        dataSource: String,
        hideInternal: Boolean,
        hideExternal: Boolean
    }
};
</script>
